import * as iconosSalud from "assets/icons/programa-salud";

export const INSIDE_DRAWER = {
  admin: {
    service_name: "Administración",
    show_drawer: true,
    isOpen: false,
    route: "administracion?servicio=",
  },
  config: {
    service_name: "Configuración",
    show_drawer: true,
    isOpen: false,
    route: "configuracion?servicio=",
  },
  users: {
    service_name: "Usuarios",
    show_drawer: true,
    isOpen: false,
    route: "usuarios",
  },
};

export const Routes = {
  login: {
    route: "/login",
  },
  dashboard: {
    route: "/",
    wordKey: "Home",
    showMenuItem: true,
    needSuperAuth: false,
  },

  usuarios: {
    route: "/usuario",
    wordKey: "Administrativos",
    showMenuItem: true,
    needSuperAuth: false,
  },
  usuarios: {
    route: "/navidad",
    wordKey: "Navidad",
    showMenuItem: true,
    needSuperAuth: false,
  },
  administracion: {
    route: "/administracion",
    wordKey: "Administracion de Usuarios",
    showMenuItem: false,
    needSuperAuth: false,
  },
  dashboardDatosPersonales: {
    route: "/administracion/dashboard-usuarios",
    wordKey: "Datos Personales",
    showMenuItem: false,
    needSuperAuth: false,
  },

  usuariosXServicio: {
    route: "/usuarios-x-servicio",
    wordKey: "Usuarios x servicio",
    showMenuItem: false,
    needSuperAuth: false,
  },
  usuariosGlobales: {
    route: "/usuarios-globales",
    wordKey: "Usuarios Globales",
    showMenuItem: false,
    needSuperAuth: false,
  }
};

/**
 * Icono propio de un item del menu, opcional.
 *
 * El drawer dibuja un icono generico para todas las hojas y otro para todos los grupos. Con
 * `icon` una ruta puede traer el suyo, y la que no lo declara sigue con el de siempre: el
 * mecanismo es de cualquier servicio, no solo de salud.
 */
export const servicesRoutes = {
  // Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).
  // IDBASE: [
  // {
  // route: "/usuarios",
  // wordKey: "Usuarios",
  // isGroup: false,
  // }
  // ],
  // Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).
  // RNCALOR: [
  // {
  // route: "/beneficiarios",
  // wordKey: "Beneficiarios",
  // isGroup: false,
  // },
  // {
  // route: "/despachantes",
  // wordKey: "Despachantes",
  // isGroup: false,
  // },

  // {
  // route: "/usuarios",
  // wordKey: "Administrativos",
  // isGroup: false,
  // },
  // ],
  // Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).
  // RNES: [
  // {
  // route: "/rubros",
  // wordKey: "Rubros",
  // isGroup: false,
  // },
  // {
  // route: "/articulos",
  // wordKey: "Articulos",
  // isGroup: false,
  // },
  // {
  // route: "/beneficiarios",
  // wordKey: "Beneficiarios",
  // isGroup: false,
  // },
  // {
  // route: "/despachantes",
  // wordKey: "Despachantes",
  // isGroup: false,
  // },
  // {
  // route: "/usuarios",
  // wordKey: "Administrativos",
  // isGroup: false,
  // },
  // {
  // route: "/informes",
  // wordKey: "Informes",
  // isGroup: false,
  // },

  // ],
  // Fuera de esta entrega: solo se expone Programa Salud (RNSALUD).
  // RNPSOCIAL: [
  // {
  // route: "/programas",
  // wordKey: "Programas",
  // isGroup: false,
  // },
  // {
  // route: "/beneficiarios",
  // wordKey: "Beneficiarios",
  // isGroup: false,
  // },
  // {
  // route: "/comercios",
  // wordKey: "Comercios",
  // isGroup: false,
  // },
  // {
  // route: "/usuarios",
  // wordKey: "Administrativos",
  // isGroup: false,
  // },
  // {
  // route: "/informes",
  // wordKey: "Informes",
  // isGroup: false,
  // },

  // ],
  RNSALUD: [
    {
      route: "/usuarios-internos",
      wordKey: "Usuarios Internos",
      isGroup: false,
      icon: iconosSalud.UsuariosInternos,
    },
    {
      route: "/estructuras",
      wordKey: "Estructura",
      isGroup: true,
      icon: iconosSalud.Estructura,
      routes: [
        {
          route: "/zonas",
          wordKey: "Zonas Sanitarias",
          isGroup: false,
          icon: iconosSalud.ZonasSanitarias,
        },
        {
          route: "/areas",
          wordKey: "Áreas Programa",
          isGroup: false,
          icon: iconosSalud.AreasPrograma,
        },
        {
          route: "/niveles",
          wordKey: "Niveles de Complejidad",
          isGroup: false,
          icon: iconosSalud.NivelesDeComplejidad,
        },
        {
          route: "/hospitales",
          wordKey: "Hospitales",
          isGroup: false,
          icon: iconosSalud.Hospitales,
        },
        {
          route: "/departamentos",
          wordKey: "Departamentos",
          isGroup: false,
          icon: iconosSalud.Departamentos,
        },
        {
          route: "/divisiones",
          wordKey: "Divisiones",
          isGroup: false,
          icon: iconosSalud.Divisiones,
        },
        {
          route: "/unidades",
          wordKey: "Unidades",
          isGroup: false,
          icon: iconosSalud.Unidades,
        },
        {
          route: "/caps",
          wordKey: "CAPS",
          isGroup: false,
          icon: iconosSalud.CAPS,
        },
        {
          route: "/uresa",
          wordKey: "URESA",
          isGroup: false,
          icon: iconosSalud.URESA,
        },
        {
          route: "/puestos",
          wordKey: "Puestos Sanitarios",
          isGroup: false,
          icon: iconosSalud.PuestosSanitarios,
        },
        {
          route: "/postas",
          wordKey: "Postas Sanitarias",
          isGroup: false,
          icon: iconosSalud.PostasSanitarias,
        },
      ]
    },
    {
      route: "/organigrama",
      wordKey: "Organigrama",
      isGroup: false,
      icon: iconosSalud.Organigrama,
    },
    // {
    //   route: "/personal",
    //   wordKey: "Personal",
    //   isGroup: true,
    //   icon: iconosSalud.Personal,
    //   // El orden no es alfabetico: primero los catalogos con los que se define un
    //   // agente —cargo, convenio, funcion, titulo— y al final Agentes, que es la
    //   // pantalla que los usa.
    //   routes: [
    //     {
    //       route: "/cargos",
    //       wordKey: "Cargos",
    //       isGroup: false,
    //       icon: iconosSalud.Cargos,
    //     },
    //     {
    //       route: "/regimenesHorario",
    //       wordKey: "Regímenes Horarios",
    //       isGroup: false,
    //       icon: iconosSalud.Convenios,
    //     },
    //     {
    //       route: "/agrupamientos",
    //       wordKey: "Agrupamientos",
    //       isGroup: false,
    //       icon: iconosSalud.Agrupamientos,
    //     },
    //     {
    //       route: "/funciones",
    //       wordKey: "Funciones",
    //       isGroup: false,
    //       icon: iconosSalud.Funciones,
    //     },
    //     {
    //       route: "/titulos",
    //       wordKey: "Títulos",
    //       isGroup: false,
    //       icon: iconosSalud.Titulos,
    //     },
    //     {
    //       // Catálogo de jornadas. NO es Control de Horarios: aquella es la planilla
    //       // mensual de turnos y vive afuera del grupo. Esta define qué jornadas
    //       // existen, con sus franjas.
    //       // TODO: icono propio. Por ahora comparte el de Control de Horarios.
    //       route: "/horarios",
    //       wordKey: "Horarios",
    //       isGroup: false,
    //       icon: iconosSalud.ControlHorarios,
    //     },
    //     {
    //       route: "/agentes",
    //       wordKey: "Agentes",
    //       isGroup: false,
    //       icon: iconosSalud.Agentes,
    //     },
    //   ]
    // },
    // {
    //   route: "/componentes-secundarios",
    //   wordKey: "Componentes secundarios",
    //   isGroup: false,
    // },
    // {
    //   route: "/feriados",
    //   wordKey: "Feriados",
    //   isGroup: true,
    //   icon: iconosSalud.Feriados,
    //   routes: [
    //     {
    //       route: "/nombres",
    //       wordKey: "Nombres de Feriados",
    //       isGroup: false,
    //       icon: iconosSalud.Feriados,
    //     },
    //     {
    //       route: "/series",
    //       wordKey: "Series de Feriados",
    //       isGroup: false,
    //       icon: iconosSalud.SeriesFeriados,
    //     },
    //   ],
    // },
    // {
    //   // Son DOS tablas y conviene que el menu lo muestre: el feriado es el concepto
    //   // —su nombre y su tipo— y la serie son sus fechas, un registro por año.
    //   route: "/controlHorarios",
    //   wordKey: "Control de Horarios",
    //   isGroup: true,
    //   icon: iconosSalud.ControlHorarios,
    //   routes: [
    //     {
    //       route: "/rotativos",
    //       wordKey: "Turnos Rotativos",
    //       isGroup: false,
    //       icon: iconosSalud.ControlHorarios,
    //     },
    //     {
    //       route: "/extraordinarios",
    //       wordKey: "Turnos Extraordinarios",
    //       isGroup: false,
    //       icon: iconosSalud.ControlHorarios,
    //     },
    //   ],
    // },
    // {
    //   route: "/controlHorarios",
    //   wordKey: "Control de Horarios",
    //   isGroup: false,
    //   icon: iconosSalud.ControlHorarios,

    // },
  ],
};
